export enum RecruitmentPathTestType {
    TEST_1 = 'TEST_1',
    TEST_2 = 'TEST_2',
    TEST_3 = 'TEST_3',
}